/**  
 * 美国站 FBA 费率配置 (2025)
 * 使用期间: 2025年1月16日 - 2026年1月14日
 */
import { SiteConfig } from '../types';
import { in2cm, lb2kg, oz2kg } from '../helpers';

export const US_CONFIG_2025: SiteConfig = {
    currency: '$',
    lowPriceThreshold: 10.00,
    storageFees: {
        standard: { jan_sep: 0.78, oct_dec: 2.40, unit: 'cu_ft' },
        oversize: { jan_sep: 0.56, oct_dec: 1.40, unit: 'cu_ft' }
    },
    // 2025年使用附加费方式
    peakSurcharge: {
        standard: 0.35,  // 标准件高峰期附加费
        oversize: 2.50   // 大件高峰期附加费
    },
    lithiumBatteryFee: 0.11,
    sizeTiers: {
        // 标准费率 (非高峰期: 1月16日-10月14日)
        standard: [
            // Small Standard
            { tierName: 'Small Standard (4oz)', maxWeight: oz2kg(4), maxEdge: [in2cm(15), in2cm(12), in2cm(0.75)], fee: 3.22, unit: 'oz' },
            { tierName: 'Small Standard (8oz)', maxWeight: oz2kg(8), maxEdge: [in2cm(15), in2cm(12), in2cm(0.75)], fee: 3.40, unit: 'oz' },
            { tierName: 'Small Standard (12oz)', maxWeight: oz2kg(12), maxEdge: [in2cm(15), in2cm(12), in2cm(0.75)], fee: 3.58, unit: 'oz' },
            { tierName: 'Small Standard (16oz)', maxWeight: oz2kg(16), maxEdge: [in2cm(15), in2cm(12), in2cm(0.75)], fee: 3.77, unit: 'oz' },

            // Large Standard - 完整重量段
            { tierName: 'Large Standard (4oz)', maxWeight: oz2kg(4), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 3.86, unit: 'oz' },
            { tierName: 'Large Standard (8oz)', maxWeight: oz2kg(8), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 4.08, unit: 'oz' },
            { tierName: 'Large Standard (12oz)', maxWeight: oz2kg(12), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 4.24, unit: 'oz' },
            { tierName: 'Large Standard (16oz)', maxWeight: oz2kg(16), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 4.75, unit: 'oz' },
            { tierName: 'Large Standard (1.25lb)', maxWeight: lb2kg(1.25), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 4.98, unit: 'lb' },
            { tierName: 'Large Standard (1.5lb)', maxWeight: lb2kg(1.5), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 5.33, unit: 'lb' },
            { tierName: 'Large Standard (1.75lb)', maxWeight: lb2kg(1.75), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 5.42, unit: 'lb' },
            { tierName: 'Large Standard (2lb)', maxWeight: lb2kg(2), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 5.68, unit: 'lb' },
            { tierName: 'Large Standard (2.25lb)', maxWeight: lb2kg(2.25), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 5.87, unit: 'lb' },
            { tierName: 'Large Standard (2.5lb)', maxWeight: lb2kg(2.5), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 6.10, unit: 'lb' },
            { tierName: 'Large Standard (2.75lb)', maxWeight: lb2kg(2.75), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 6.25, unit: 'lb' },
            { tierName: 'Large Standard (3lb)', maxWeight: lb2kg(3), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 6.39, unit: 'lb' },
            { tierName: 'Large Standard (4lb)', maxWeight: lb2kg(4), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 7.17, unit: 'lb' },
            { tierName: 'Large Standard (5lb)', maxWeight: lb2kg(5), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 7.63, unit: 'lb' },
            { tierName: 'Large Standard (10lb)', maxWeight: lb2kg(10), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 10.11, unit: 'lb' },
            { tierName: 'Large Standard (15lb)', maxWeight: lb2kg(15), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 13.20, unit: 'lb' },
            { tierName: 'Large Standard (20lb)', maxWeight: lb2kg(20), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 17.44, unit: 'lb' },
        ],

        // 低价费率 (售价 ≤ $10，非服装)
        lowPrice: [
            { tierName: 'Small Standard (4oz) Low-Price', maxWeight: oz2kg(4), maxEdge: [in2cm(15), in2cm(12), in2cm(0.75)], fee: 2.45, unit: 'oz' },
            { tierName: 'Small Standard (8oz) Low-Price', maxWeight: oz2kg(8), maxEdge: [in2cm(15), in2cm(12), in2cm(0.75)], fee: 2.63, unit: 'oz' },
            { tierName: 'Small Standard (12oz) Low-Price', maxWeight: oz2kg(12), maxEdge: [in2cm(15), in2cm(12), in2cm(0.75)], fee: 2.81, unit: 'oz' },
            { tierName: 'Small Standard (16oz) Low-Price', maxWeight: oz2kg(16), maxEdge: [in2cm(15), in2cm(12), in2cm(0.75)], fee: 3.00, unit: 'oz' },
            { tierName: 'Large Standard (4oz) Low-Price', maxWeight: oz2kg(4), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 3.09, unit: 'oz' },
            { tierName: 'Large Standard (8oz) Low-Price', maxWeight: oz2kg(8), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 3.31, unit: 'oz' },
            { tierName: 'Large Standard (12oz) Low-Price', maxWeight: oz2kg(12), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 3.47, unit: 'oz' },
            { tierName: 'Large Standard (16oz) Low-Price', maxWeight: oz2kg(16), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 3.98, unit: 'oz' },
            { tierName: 'Large Standard (1.25lb) Low-Price', maxWeight: lb2kg(1.25), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 4.21, unit: 'lb' },
            { tierName: 'Large Standard (1.5lb) Low-Price', maxWeight: lb2kg(1.5), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 4.56, unit: 'lb' },
            { tierName: 'Large Standard (2lb) Low-Price', maxWeight: lb2kg(2), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 4.91, unit: 'lb' },
            { tierName: 'Large Standard (2.5lb) Low-Price', maxWeight: lb2kg(2.5), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 5.33, unit: 'lb' },
            { tierName: 'Large Standard (3lb) Low-Price', maxWeight: lb2kg(3), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 5.62, unit: 'lb' },
        ],

        // 服装类标准费率
        apparel: [
            { tierName: 'Small Standard (4oz) Apparel', maxWeight: oz2kg(4), maxEdge: [in2cm(15), in2cm(12), in2cm(0.75)], fee: 3.43, unit: 'oz' },
            { tierName: 'Large Standard (1lb) Apparel', maxWeight: lb2kg(1), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 4.43, unit: 'lb' },
            { tierName: 'Large Standard (2lb) Apparel', maxWeight: lb2kg(2), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 5.75, unit: 'lb' },
        ],

        // 服装类低价费率 (售价 ≤ $10)
        apparelLowPrice: [
            { tierName: 'Small Standard (4oz) Apparel Low-Price', maxWeight: oz2kg(4), maxEdge: [in2cm(15), in2cm(12), in2cm(0.75)], fee: 2.66, unit: 'oz' },
            { tierName: 'Large Standard (1lb) Apparel Low-Price', maxWeight: lb2kg(1), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 3.66, unit: 'lb' },
            { tierName: 'Large Standard (2lb) Apparel Low-Price', maxWeight: lb2kg(2), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 4.98, unit: 'lb' },
        ],

        // 危险品
        dangerous: [
            { tierName: 'Small Standard (4oz) Dangerous', maxWeight: oz2kg(4), maxEdge: [in2cm(15), in2cm(12), in2cm(0.75)], fee: 4.32, unit: 'oz' },
            { tierName: 'Large Standard (1lb) Dangerous', maxWeight: lb2kg(1), maxEdge: [in2cm(18), in2cm(14), in2cm(8)], fee: 5.36, unit: 'lb' },
        ]
    }
};
